import { render, staticRenderFns } from "./CustomerEditAccount.vue?vue&type=template&id=5a7d10aa&"
import script from "./CustomerEditAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerEditAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports